<template>
  <div class="main">
    <div class="screen_wrap">
      <div>
        <div class="first">
          <span>种类：</span>
          <span class="screen_item" :class="{'active':category_id===''}" @click="handleClickCate('')">全部</span>
          <span class="screen_item" :class="{'active':category_id===item.id}" @click="handleClickCate(item.id)"
                v-for="item in kindList"
                :key="item.id">{{ item.name }}</span>
        </div>
        <div class="second">
          <div>
            <span>类型：</span>
            <span class="screen_item" :class="{'act':sale_type===''}" @click="handleClickType('')">全部</span>
            <span class="screen_item" :class="{'act':sale_type==='0'}" @click="handleClickType('0')">免费</span>
            <span class="screen_item" :class="{'act':sale_type==='1'}" @click="handleClickType('1')">付费</span>
          </div>
          <el-button type="primary" size="small" @click="handleDownCCMAX">下载ccMAX</el-button>
        </div>
      </div>
    </div>
    <ul class="ccmax_list">
      <li class="ccmax_item" v-for="item in ccMaxList" :key="item.id" @click="handleClickDetail(item)">
        <div class="item_inner">
          <img class="item_cover" :src="item.cover" alt="">
          <h4 class="item_title">{{ item.title }}</h4>
          <div class="item_info">
            <span>种类 - {{ item.category_name }}</span>
            <span class="divide"> | </span>
            <span>类型 - {{ item.sale_type === '1' ? '付费' : '免费' }}</span>
          </div>
        </div>
      </li>
    </ul>
    <el-pagination @current-change="handleCurrentChange"
                   :current-page="currentPage"
                   layout="pager"
                   :page-size="20"
                   v-if="total > 20"
                   :total="total">
    </el-pagination>
  </div>
</template>
<script>
export default {
  name: "ccMax",
  data() {
    return {
      kindList: [],
      category_id: '',
      sale_type: '',
      ccMaxList: [],
      currentPage: 1,
      total: 0,
      keyword: '',
    }
  },
  created() {
  },
  mounted() {
    this.$store.dispatch("post", {url: "ccmax_cateGory",}).then((res) => {
      if (res.status === 0) {
        this.kindList = res.data;
      } else {
        this.$message.error(res.msg)
      }
    });

    this.getCCMaxList()
  },
  methods: {
    getCCMaxList() {
      this.loading = true;
      this.$store.dispatch('post', {
        url: 'ccmax_list', data: {
          category_id: this.category_id,
          keyword: this.keyword,
          sale_type: this.sale_type
        }
      }).then(res => {
        if (res.status === 0) {
          const {data} = res;
          this.total = Number(data.count);
          this.ccMaxList = data.list
        } else {
          this.$message.error(res.msg)
        }
      })
    },

    handleClickCate(id) {
      this.category_id = id;
      this.getCCMaxList();
    },

    handleClickType(id) {
      this.sale_type = id;
      this.getCCMaxList();
    },

    handleClickDetail(obj) {
      this.$router.push({
        path: '/ccMax_detail',
        query: {
          id: obj.id
        }
      })
    },

    handleDownCCMAX() {
      window.open('https://www.hirender.com/#/product-ccMax')
    },

    handleCurrentChange(val) {
      this.currentPage = val;
      this.getCCMaxList();
    },
  },

  watch: {
    $route: {
      handler: function (val, oldVal) {
        if (val.query.keyword != oldVal.query.keyword) {
          this.keyword = val.query.keyword
          this.getCCMaxList()
        }
      }
    }
  }
}
</script>
<style lang="less" scoped>
.screen_wrap {
  width: 1300px;
  margin: 0 auto;
  position: relative;
  padding: 15px 32px;
  font-size: 14px;
  border-radius: 10px;
  background-color: #ffffff;

  .first {
    margin-bottom: 16px;
  }

  .screen_item {
    margin-left: 32px;
    cursor: pointer;

    &.active {
      color: #1783FF;
    }

    &.act {
      color: #1783FF;
    }
  }

  .second {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}

.ccmax_list {
  width: 1300px;
  margin: 20px auto 0;
  display: flex;
  flex-wrap: wrap;
  min-height: 430px;

  .ccmax_item {
    width: 25%;
    box-sizing: border-box;
    overflow: hidden;
    height: fit-content;
    padding-right: 20px;
    padding-bottom: 20px;

    &:nth-child(4n) {
      padding-right: 0;
    }

    .item_inner {
      background: #ffffff;
      box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);
      border-radius: 10px;

      .item_cover {
        height: 218px;
        width: 100%;
        border-radius: 10px 10px 0 0;
      }

      .item_title {
        font-size: 15px;
      }

      .item_title, .item_info {
        padding: 5px 10px;
        box-sizing: border-box;

        .divide {
          display: inline-block;
          margin: 0 20px;
        }
      }

      .item_info {
        padding-bottom: 10px;
      }
    }
  }
}

.sale_type {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 10px;
  margin-bottom: 10px;
  border-bottom: 1px solid #666666;
}

.images_wrap {
  h2 {
    margin-bottom: 16px;
    font-size: 16px;
  }

  .images_list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    max-height: 500px;
    overflow-y: scroll;

    .images_item {
      width: 49%;
      height: 200px;
      margin-bottom: 16px;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
}

.el-pagination {
  width: 1300px;
  margin: 0 auto 30px;
  text-align: center;
}
</style>
